export default __webpack_public_path__ + "static/media/str_family.ccba3ee8.jpg";